<template>
  <div>
    <!-- <div v-if="$route.name !== 'Maintenance'"> -->
    <!-- <div class="hidden-sm-and-down" style="position: fixed; width: 100%; height: 4px; background-color: transparent; left: 0px; right: 0px; top: 0px; z-index: 99999;">
      <div style="height: 4px; background-color: #a5ceff;" :style="{width: offsetTop + 'px'}">
      </div>
    </div>-->
    <v-toolbar
      fixed
      id="core-toolbar"
      :flat="offsetTop < 20"
      prominent
      :class="{ active: offsetTop >= 20}"
    >
      <v-btn
        :class="{ active: offsetTop >= 20 }"
        icon
        v-if="$route.name === 'Showcase'"
        @click="toPage('Portfolio')"
      >
        <v-icon id="showcase-btn" large :class="{ active: offsetTop >= 20 }">mdi-arrow-left</v-icon>
      </v-btn>
      <img
        @click="toPage('Landing')"
        class="top-margin-toolbar"
        style="cursor: pointer"
        src="/img/white-logo.png"
        height="38"
        :class="{ active: offsetTop >= 20 }"
        v-if="$route.name !== 'Showcase'"
      >
      <v-toolbar-title
        class="top-margin-toolbar white--text"
        :class="{ active: offsetTop >= 20 }"
        v-if="$route.name !== 'Showcase'"
      >EverOwl Technologies</v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items v-if="!responsive">
        <v-flex
          align-center
          layout
          py-2
          v-if="$route.name !== 'Showcase' || ($route.name === 'Showcase' && offsetTop >= 20)"
        >
          <router-link
            v-for="link in links"
            :key="link.id"
            class="top-margin-toolbar"
            :to="link.to"
            :class="{ active: offsetTop >= 20 }"
            active-class="activeToolbarItems"
          >
            <h2
              class="body-2 font-weight-bold toolbar-link"
              style="padding: 8px 0px"
              :class="{ activeToolbarItems: link.text === title.toUpperCase() }"
            >{{link.text}}</h2>
          </router-link>
        </v-flex>
      </v-toolbar-items>
    </v-toolbar>

    <div v-if="responsive">
      <!-- NAV FOR MOBILE VIEW -->
      <v-container class="cd-primary-nav text-xs-center">
        <v-layout row wrap>
          <v-flex align-center layout py-2>
            <nav>
              <ul class="cd-primary-nav">
                <li>
                  <a
                    @click="toMobliePage('About Us')"
                    :class="{ activeMobileToolbarItems: 'About Us' === title }"
                  >ABOUT US</a>
                </li>
                <li>
                  <a
                    @click="toMobliePage('Web Development')"
                    :class="{ activeMobileToolbarItems: 'Web Development' === title }"
                  >WEBSITE</a>
                </li>
                <li>
                  <a
                    @click="toMobliePage('App Development')"
                    :class="{ activeMobileToolbarItems: 'App Development' === title }"
                  >MOBILE APPLICATION</a>
                </li>
                <li>
                  <a
                    @click="toMobliePage('Portfolio')"
                    :class="{ activeMobileToolbarItems: 'Portfolio' === title }"
                  >PORTFOLIO</a>
                </li>
                <li>
                  <a
                    @click="toMobliePage('Contact Us')"
                    :class="{ activeMobileToolbarItems: 'Contact Us' === title }"
                  >CONTACT US</a>
                </li>
              </ul>
            </nav>
          </v-flex>
        </v-layout>
      </v-container>

      <div class="cd-overlay-nav">
        <span></span>
      </div>
      <div class="cd-overlay-content">
        <span></span>
      </div>

      <a class="cd-nav-trigger" @click="performMenuAnimation">Menu
        <span class="cd-icon"></span>
      </a>
    </div>

    <!-- Landing-area -->
    <header
      class="home-area overlay angle softShift"
      v-if="$route.name === 'Landing'"
      style="padding-top: 100px;"
    >
      <v-container class="py-0 px-4" style="max-width: 1300px;">
        <v-layout row justify-center class="animate-banner-landing">
          <v-flex class="mt-5 px-3 xs12 md7 lg7 hidden-sm-and-down">
            <figure class="mobile-image">
              <img style="max-width: 95%;  " src="/img/Landing-Intro.png" alt>
            </figure>
          </v-flex>
          <v-flex class="xs12 md5 lg5">
            <div class="space-90 hidden-sm-and-down"></div>
            <div class="hidden-sm-and-down">
              <h1 class="font-weight-black landing-header-text">Get Started
                <br>On Your
              </h1>
              <h1 class="my-0 font-weight-black landing-header-text">
                <vue-typer
                  color="white"
                  :text="['Website','Mobile Application','Design']"
                  :repeat="Infinity"
                  :shuffle="false"
                  initial-action="erasing"
                  :pre-type-delay="70"
                  :type-delay="70"
                  :pre-erase-delay="2000"
                  :erase-delay="200"
                  erase-style="backspace"
                  :erase-on-complete="false"
                  caret-animation="expand"
                ></vue-typer>
              </h1>
            </div>
            <div class="sm-and-down hidden-md-and-up">
              <h1 class="font-weight-black">Get Started On Your Dreams!</h1>
            </div>
            <div class="space-20"></div>
            <div>
              <p
                class="font-weight-medium"
                style="font-size: 16px !important"
              >The price of success is hard work, dedication to the job, and determination. We applied the best of Owl-selves to the task at hand to achieve your goals.</p>
            </div>
            <div class="space-20"></div>
            <a @click="toPage('Contact Us')" class="bttn-white mb-5">
              <i class="lnr lnr-download"></i>Contact Us
            </a>
          </v-flex>
        </v-layout>
      </v-container>
    </header>

    <!-- Contact-area -->
    <header class="home-area overlay angle softShift" v-if="$route.name === 'Contact Us'">
      <v-container class="py-0 px-4">
        <v-layout row justify-center class="animate-banner-contact-us">
          <v-flex class="xs12 md7 lg6">
            <div class="space-80 hidden-sm-and-down"></div>
            <div class="hidden-sm-and-down">
              <h1 class="font-weight-black">Get In Touch By</h1>
              <h1 class="my-0 font-weight-black">
                <vue-typer
                  color="white"
                  :text="['Emailing Us', 'Calling Us', 'Submitting Form']"
                  :repeat="Infinity"
                  :shuffle="false"
                  initial-action="erasing"
                  :pre-type-delay="70"
                  :type-delay="70"
                  :pre-erase-delay="2000"
                  :erase-delay="200"
                  erase-style="backspace"
                  :erase-on-complete="false"
                  caret-animation="expand"
                ></vue-typer>
              </h1>
            </div>
            <div class="sm-and-down hidden-md-and-up">
              <h1 class="font-weight-black">Contact Us Now!
                <br>We Dont Bite.
              </h1>
            </div>
            <div class="space-20"></div>
            <div>
              <p
                class="font-weight-medium"
                style="font-size: 16px !important"
              >We are here to help you answer any doubts or questions that you may have. We look forward to hearing from you soon. Also, dont forget to subscribe to our newsletter!</p>
            </div>
            <div class="space-20"></div>
            <a @click="$vuetify.goTo('#contact')" class="bttn-white">
              <i class="lnr lnr-download"></i>Submit Form
            </a>
          </v-flex>
          <v-flex class="px-3 xs12 md5 lg4 hidden-sm-and-down">
            <figure class="mobile-image">
              <img style="max-width: 130%;" src="/img/header-mobile-contact.png" alt>
            </figure>
          </v-flex>
        </v-layout>
      </v-container>
    </header>

    <!-- Web-Dev-area -->
    <header
      class="home-area overlay angle softShift"
      v-if="$route.name === 'Web Development'"
      style="padding-top: 100px;"
    >
      <v-container class="py-0 px-4" style="max-width: 1300px;">
        <v-layout row justify-center class="animate-banner-web-dev">
          <v-flex class="mt-5 px-3 xs12 md7 lg7 hidden-sm-and-down">
            <figure class="mobile-image">
              <img style="max-width: 95%;  " src="/img/Web-Dev-Intro.png" alt>
            </figure>
          </v-flex>
          <v-flex class="xs12 md5 lg5">
            <div class="space-90 hidden-sm-and-down"></div>
            <div class="hidden-sm-and-down">
              <h1 class="font-weight-black landing-header-text">We Cater Towards</h1>
              <h1 class="my-0 font-weight-black landing-header-text">
                <vue-typer
                  color="white"
                  :text="['Website Design','Website Application','E-Commerce']"
                  :repeat="Infinity"
                  :shuffle="false"
                  initial-action="erasing"
                  :pre-type-delay="70"
                  :type-delay="70"
                  :pre-erase-delay="2000"
                  :erase-delay="200"
                  erase-style="backspace"
                  :erase-on-complete="false"
                  caret-animation="expand"
                ></vue-typer>
              </h1>
            </div>
            <div class="sm-and-down hidden-md-and-up">
              <h1 class="font-weight-black">Need A Website?
                <br>We Got You Covered!
              </h1>
            </div>
            <div class="space-20"></div>
            <div>
              <p
                class="font-weight-medium"
                style="font-size: 16px !important"
              >Let’s get started and create a website for your online businesses. We assure that the design of your website promotes a flawless user experience and capture the attention of your audience. Let's work together and see the difference with the leading web development company in Malaysia.</p>
            </div>
            <div class="space-20"></div>
            <a @click="toPage('Contact Us')" class="bttn-white mb-5">
              <i class="lnr lnr-download"></i>Get In Touch
            </a>
          </v-flex>
        </v-layout>
      </v-container>
    </header>

    <!-- About-Us-area -->
    <header
      class="home-area overlay angle softShift"
      v-if="$route.name === 'About Us'"
      style="padding-top:100px"
    >
      <v-container class="py-0 px-4" style="max-width: 1300px;">
        <v-layout row justify-center class="animate-banner-about-us">
          <v-flex class="px-4 xs12 md6 lg6 hidden-sm-and-down">
            <figure class="mobile-image">
              <img
                style="max-width: 70%;
    margin-right: 17%;
    float: right; height: auto; "
                src="/img/Everowls-Business-Cards.png"
                alt
              >
            </figure>
          </v-flex>
          <v-flex class="xs12 md6 lg6">
            <v-layout align-start justify-center column fill-height>
              <div class="space-100 hidden-md-and-down"></div>
              <div class="hidden-sm-and-down">
                <h1 class="font-weight-black">Let's Talk About</h1>
                <h1 class="my-0 font-weight-black">
                  <vue-typer
                    color="white"
                    :text="['Owl Vision', 'The Team', 'What We Do']"
                    :repeat="Infinity"
                    :shuffle="false"
                    initial-action="erasing"
                    :pre-type-delay="70"
                    :type-delay="80"
                    :pre-erase-delay="2500"
                    :erase-delay="80"
                    erase-style="backspace"
                    :erase-on-complete="false"
                    caret-animation="expand"
                  ></vue-typer>
                </h1>
              </div>
              <div class="sm-and-down hidden-md-and-up">
                <h1 class="font-weight-black">Owl Vision, The Team, and What We Do.</h1>
              </div>
              <div class="pl-1">
                <div class="space-20"></div>
                <div class="mb-3" style="border: 2px solid #fff; max-width: 150px"></div>
                <div>
                  <p
                    class="font-weight-medium"
                    style="font-size: 16px !important"
                  >Teamwork makes the dream work. We have been responsible for bringing concepts to reality for various client. Now, let us take you behind the scene on what drives the engine to your success.</p>
                </div>
              </div>
              <div class="space-20"></div>
              <div class="space-60 hidden-md-and-down"></div>
              <div class="space-40 hidden-lg-only"></div>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </header>

    <!-- Portfolio-area -->
    <header
      class="home-area overlay angle softShift"
      v-if="$route.name === 'Portfolio'"
      style="padding-top: 110px;"
    >
      <v-container class="py-0 px-4" style="max-width: 1300px;">
        <v-layout row justify-center class="animate-banner-portfolio">
          <v-flex class="px-4 xs12 md7 lg7 hidden-sm-and-down">
            <div class="space-40 hidden-md-and-down"></div>
            <div class="space-50 hidden-sm-and-down"></div>
            <figure class="mobile-image">
              <img style="max-width: 95%; height: auto; " src="/img/Portfolio-Intro.png" alt>
            </figure>
          </v-flex>
          <v-flex class="xs12 md5 lg5">
            <div class="space-100 hidden-md-and-down"></div>
            <div class="hidden-sm-and-down">
              <h1 class="font-weight-black">Discover Our</h1>
              <h1 class="my-0 font-weight-black">
                <vue-typer
                  color="white"
                  :text="['Concepts!', 'Applications!', 'Websites!']"
                  :repeat="Infinity"
                  :shuffle="false"
                  initial-action="erasing"
                  :pre-type-delay="70"
                  :type-delay="80"
                  :pre-erase-delay="2500"
                  :erase-delay="80"
                  erase-style="backspace"
                  :erase-on-complete="false"
                  caret-animation="expand"
                ></vue-typer>
              </h1>
            </div>
            <div class="sm-and-down hidden-md-and-up">
              <h1 class="font-weight-black">Discover Our Work & Design!</h1>
            </div>
            <div class="pl-1">
              <div class="space-20"></div>
              <div class="mb-3" style="border: 2px solid #fff; max-width: 150px"></div>
              <div>
                <p
                  class="font-weight-medium"
                  style="font-size: 16px !important"
                >Why just believe what we say. Take some time and view our portfolio collection to help you better assess your potential goal getters. Trust us, we wont disappoint.</p>
              </div>
            </div>
            <div class="space-20"></div>
            <div class="space-60 hidden-md-and-down"></div>
            <div class="space-40 hidden-lg-only"></div>
          </v-flex>
        </v-layout>
      </v-container>
    </header>

    <!-- App-Dev-area -->
    <header
      class="home-area overlay angle softShift"
      style="padding-top: 80px"
      v-if="$route.name === 'App Development'"
    >
      <v-container class="py-0 px-4">
        <v-layout row justify-center class="animate-banner-app-dev">
          <v-flex class="px-3 xs12 md5 lg5 hidden-sm-and-down">
            <figure class="web-mobile-image">
              <img
                style="max-width: 95%; height: auto; "
                src="/img/Gravity-Application-Development.png"
                alt
              >
            </figure>
          </v-flex>
          <v-flex class="xs12 md7 lg5">
            <v-layout align-start justify-center column fill-height>
              <div class="hidden-sm-and-down">
                <h1 class="font-weight-black">We Cater Towards</h1>
                <h1 class="my-0 font-weight-black">
                  <vue-typer
                    color="white"
                    :text="['Cross-Platform App','Native Application']"
                    :repeat="Infinity"
                    :shuffle="false"
                    initial-action="erasing"
                    :pre-type-delay="70"
                    :type-delay="80"
                    :pre-erase-delay="2000"
                    :erase-delay="70"
                    erase-style="backspace"
                    :erase-on-complete="false"
                    caret-animation="expand"
                  ></vue-typer>
                </h1>
              </div>
              <div class="sm-and-down hidden-md-and-up">
                <h1 class="font-weight-black">We Cater Towards
                  <br>Cross-Platform Application!
                </h1>
              </div>
              <div class="space-20"></div>
              <div>
                <p
                  class="font-weight-medium"
                  style="font-size: 16px !important"
                >Let's get started on your mobile application. We support both natively and cross-development as well. Our design helps ensure your user experience is always captivating to capture your audience's attention.</p>
              </div>
              <div class="space-20"></div>
              <a @click="toPage('Contact Us')" class="bttn-white">
                <i class="lnr lnr-download"></i>Get In Touch
              </a>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </header>
    <!-- Header-area -->
    <div @click="$vuetify.goTo(0)" class="back-top-btn" v-if="offsetTop >= 20 && innerWidth <= 768"></div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data: () => ({
    showNav: false,
    isActive: false,
    links: [
      {
        to: "/about-us",
        text: "ABOUT US"
      },
      {
        to: "/web-development",
        text: "WEB DEVELOPMENT"
      },
      {
        to: "/app-development",
        text: "APP DEVELOPMENT"
      },
      {
        to: "/portfolio",
        text: "PORTFOLIO"
      },
      {
        to: "/contact-us",
        text: "CONTACT US"
      }
    ],
    title: "",
    responsive: false,
    responsiveInput: false,
    offsetTop: 0,
    innerWidth: 0
  }),

  watch: {
    $route(val) {
      this.title = val.name;
    }
  },

  mounted() {
    this.innerWidth = window.innerWidth;
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    var $maxHeight = $(window).height();
    $(window).scroll(() => {
      var $height = $(window).scrollTop();
      if (
        $height === 0 ||
        $height - 100 < this.offsetTop ||
        $height > this.offsetTop + 100 ||
        $height === $maxHeight
      ) {
        this.offsetTop = $height;
      }
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    toPage(name) {
      this.$router.push({ name: name });
    },

    toMobliePage(name) {
      this.$router.push({ name: name });
      this.performMenuAnimation();
    },

    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },

    onClick() {
      //
    },

    onResponsiveInverted() {
      if (window.innerWidth < 1055) {
        this.responsive = true;
        this.responsiveInput = false;
        this.layerInit();
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },

    performMenuAnimation() {
      var overlayNav = $(".cd-overlay-nav"),
        overlayContent = $(".cd-overlay-content"),
        navigation = $(".cd-primary-nav"),
        toggleNav = $(".cd-nav-trigger");
      if (!toggleNav.hasClass("close-nav")) {
        //it means navigation is not visible yet - open it and animateee navigation layer
        toggleNav.addClass("close-nav");
        overlayNav.children("span").velocity(
          {
            translateZ: 0,
            scaleX: 1,
            scaleY: 1
          },
          500,
          "easeInCubic",
          function() {
            navigation.addClass("fade-in");
          }
        );
      } else {
        //navigation is open - close it and remove navigation layer
        toggleNav.removeClass("close-nav");

        overlayContent.children("span").velocity(
          {
            translateZ: 0,
            scaleX: 1,
            scaleY: 1
          },
          500,
          "easeInCubic",
          function() {
            navigation.removeClass("fade-in");

            overlayNav.children("span").velocity(
              {
                translateZ: 0,
                scaleX: 0,
                scaleY: 0
              },
              0
            );
            overlayContent
              .addClass("is-hidden")
              .one(
                "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
                function() {
                  overlayContent.children("span").velocity(
                    {
                      translateZ: 0,
                      scaleX: 0,
                      scaleY: 0
                    },
                    0,
                    function() {
                      overlayContent.removeClass("is-hidden");
                    }
                  );
                }
              );
            if ($("html").hasClass("no-csstransitions")) {
              overlayContent.children("span").velocity(
                {
                  translateZ: 0,
                  scaleX: 0,
                  scaleY: 0
                },
                0,
                function() {
                  overlayContent.removeClass("is-hidden");
                }
              );
            }
          }
        );
      }
    },

    layerInit() {
      var overlayNav = $(".cd-overlay-nav"),
        overlayContent = $(".cd-overlay-content"),
        navigation = $(".cd-primary-nav"),
        toggleNav = $(".cd-nav-trigger");

      var diameterValue =
        Math.sqrt(
          Math.pow($(window).height(), 2) + Math.pow($(window).width(), 2)
        ) * 2;
      overlayNav
        .children("span")
        .velocity(
          {
            scaleX: 0,
            scaleY: 0,
            translateZ: 0
          },
          50
        )
        .velocity(
          {
            height: diameterValue + "px",
            width: diameterValue + "px",
            top: -(diameterValue / 2) + "px",
            left: -(diameterValue / 2) + "px"
          },
          0
        );

      overlayContent
        .children("span")
        .velocity(
          {
            scaleX: 0,
            scaleY: 0,
            translateZ: 0
          },
          50
        )
        .velocity(
          {
            height: diameterValue + "px",
            width: diameterValue + "px",
            top: -(diameterValue / 2) + "px",
            left: -(diameterValue / 2) + "px"
          },
          0
        );
    }
  },

  created() {
    jQuery(document).ready(function($) {
      var overlayNav = $(".cd-overlay-nav"),
        overlayContent = $(".cd-overlay-content"),
        navigation = $(".cd-primary-nav"),
        toggleNav = $(".cd-nav-trigger");
      //inizialize navigation and content layers
      layerInit();
      $(window).on("resize", function() {
        window.requestAnimationFrame(layerInit);
      });

      function layerInit() {
        var overlayNav = $(".cd-overlay-nav"),
          overlayContent = $(".cd-overlay-content"),
          navigation = $(".cd-primary-nav"),
          toggleNav = $(".cd-nav-trigger");

        var diameterValue =
          Math.sqrt(
            Math.pow($(window).height(), 2) + Math.pow($(window).width(), 2)
          ) * 2;
        overlayNav
          .children("span")
          .velocity(
            {
              scaleX: 0,
              scaleY: 0,
              translateZ: 0
            },
            50
          )
          .velocity(
            {
              height: diameterValue + "px",
              width: diameterValue + "px",
              top: -(diameterValue / 2) + "px",
              left: -(diameterValue / 2) + "px"
            },
            0
          );

        overlayContent
          .children("span")
          .velocity(
            {
              scaleX: 0,
              scaleY: 0,
              translateZ: 0
            },
            50
          )
          .velocity(
            {
              height: diameterValue + "px",
              width: diameterValue + "px",
              top: -(diameterValue / 2) + "px",
              left: -(diameterValue / 2) + "px"
            },
            0
          );
      }
    });
  }
};
</script>

<style>
#core-toolbar {
  background-color: transparent;
  max-width: 100vw;
}

#core-toolbar.active {
  background-color: #768ede;
  opacity: 0.9;
}

#showcase-btn {
  color: rgb(0, 0, 0) !important;
}

#showcase-btn.active {
  color: rgb(255, 255, 255) !important;
}

.top-margin-toolbar {
  margin-top: 20px;
  -webkit-animation: floatInToolbarBubble 0.5s normal ease-out;
  animation: floatInToolbarBubble 0.5s normal ease-out;
}

.top-margin-toolbar.active {
  -webkit-animation: floatOutToolbarBubble 0.5s normal ease-out;
  animation: floatOutToolbarBubble 0.5s normal ease-out;
  margin-top: 0px;
}

@-webkit-keyframes floatOutToolbarBubble {
  0% {
    margin-top: 20px;
  }
  100% {
    margin-top: 0px;
  }
}
@keyframes floatOutToolbarBubble {
  0% {
    margin-top: 20px;
  }
  100% {
    margin-top: 0px;
  }
}

@-webkit-keyframes floatInToolbarBubble {
  0% {
    margin-top: 0px;
  }
  100% {
    margin-top: 20px;
  }
}
@keyframes floatInToolbarBubble {
  0% {
    margin-top: 0px;
  }
  100% {
    margin-top: 20px;
  }
}

.back-top-btn {
  display: inline-block;
  background-color: #b3d4fc;
  width: 50px;
  height: 50px;
  text-align: center;
  border-radius: 4px;
  margin: 30px;
  position: fixed;
  bottom: 0;
  right: 0;
  transition: background-color 0.3s;
  z-index: 1000;
  cursor: pointer;
  -webkit-animation: fadein 1.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1.5s; /* Firefox < 16 */
  -ms-animation: fadein 1.5s; /* Internet Explorer */
  -o-animation: fadein 1.5s; /* Opera < 12.1 */
  animation: fadein 1.5s;
}

.back-top-btn::after {
  border-style: solid;
  border-color: #fff;
  border-width: 0.25em 0.25em 0 0;
  content: "";
  display: inline-block;
  height: 1.5em;
  position: relative;
  top: 1.2em;
  transform: rotate(-45deg);
  vertical-align: top;
  width: 1.5em;
}

.back-top-btn:hover::after {
  height: 1.7em;
  width: 1.7em;
}

/* -------------------------------- 
Primary style
-------------------------------- */
*,
*::after,
*::before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

*::after,
*::before {
  content: "";
}

.toolbar-link {
  position: relative;
  padding: 1rem 0 0.5rem;
  margin: 0 1.5rem;
  color: rgb(255, 255, 255);
  text-decoration: none;
  text-transform: uppercase;
}

.toolbar-link::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%) scaleX(0);
  transform-origin: 50% 50%;
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.8);
  transition: transform 250ms;
}

.toolbar-link:hover::after {
  transform: translateX(-50%) scaleX(1);
}

.activeToolbarItems::after {
  transform: translateX(-50%) scaleX(1);
}

.activeMobileToolbarItems {
  text-decoration: line-through solid !important;
}

.animate-banner-landing {
  -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 2s; /* Firefox < 16 */
  -ms-animation: fadein 2s; /* Internet Explorer */
  -o-animation: fadein 2s; /* Opera < 12.1 */
  animation: fadein 2s;
}

.animate-banner-about-us {
  -webkit-animation: fadein2 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein2 2s; /* Firefox < 16 */
  -ms-animation: fadein2 2s; /* Internet Explorer */
  -o-animation: fadein2 2s; /* Opera < 12.1 */
  animation: fadein2 2s;
}

.animate-banner-web-dev {
  -webkit-animation: fadein3 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein3 2s; /* Firefox < 16 */
  -ms-animation: fadein3 2s; /* Internet Explorer */
  -o-animation: fadein3 2s; /* Opera < 12.1 */
  animation: fadein3 2s;
}

.animate-banner-app-dev {
  -webkit-animation: fadein4 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein4 2s; /* Firefox < 16 */
  -ms-animation: fadein4 2s; /* Internet Explorer */
  -o-animation: fadein4 2s; /* Opera < 12.1 */
  animation: fadein4 2s;
}

.animate-banner-portfolio {
  -webkit-animation: fadein5 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein5 2s; /* Firefox < 16 */
  -ms-animation: fadein5 2s; /* Internet Explorer */
  -o-animation: fadein5 2s; /* Opera < 12.1 */
  animation: fadein5 2s;
}

.animate-banner-contact-us {
  -webkit-animation: fadein6 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein6 2s; /* Firefox < 16 */
  -ms-animation: fadein6 2s; /* Internet Explorer */
  -o-animation: fadein6 2s; /* Opera < 12.1 */
  animation: fadein6 2s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadein2 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein2 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein2 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein2 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein2 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadein3 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein3 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein3 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein3 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein3 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadein4 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein4 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein4 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein4 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein4 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadein5 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein5 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein5 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein5 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein5 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadein6 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein6 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein6 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein6 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein6 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* -------------------------------- 
Main components 
-------------------------------- */
html,
body {
  height: 100%;
}

header {
  z-index: 3;
}

.cd-logo,
.cd-nav-trigger {
  position: fixed;
  display: inline-block;
}

.cd-logo {
  top: 28px;
  left: 5%;
}
.cd-logo img {
  display: block;
}

.cd-nav-trigger {
  top: 12px;
  right: 5%;
  bottom: 0;
  height: 44px;
  width: 44px;
  z-index: 5;
  /* image replacement */
  overflow: hidden;
  text-indent: 100%;
  white-space: nowrap;
}
.cd-nav-trigger .cd-icon {
  /* icon created in CSS */
  position: absolute;
  left: 50%;
  top: 50%;
  bottom: auto;
  right: auto;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  -o-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  display: inline-block;
  width: 18px;
  height: 3px;
  background-color: #768ede;
  z-index: 10;
}
.cd-nav-trigger .cd-icon::before,
.cd-nav-trigger .cd-icon:after {
  /* upper and lower lines of the menu icon */
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: #768ede;
  /* Force Hardware Acceleration in WebKit */
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  /* apply transition to transform property */
  -webkit-transition: -webkit-transform 0.3s;
  -moz-transition: -moz-transform 0.3s;
  transition: transform 0.3s;
}
.cd-nav-trigger .cd-icon::before {
  -webkit-transform: translateY(-6px) rotate(0deg);
  -moz-transform: translateY(-6px) rotate(0deg);
  -ms-transform: translateY(-6px) rotate(0deg);
  -o-transform: translateY(-6px) rotate(0deg);
  transform: translateY(-6px) rotate(0deg);
}
.cd-nav-trigger .cd-icon::after {
  -webkit-transform: translateY(6px) rotate(0deg);
  -moz-transform: translateY(6px) rotate(0deg);
  -ms-transform: translateY(6px) rotate(0deg);
  -o-transform: translateY(6px) rotate(0deg);
  transform: translateY(6px) rotate(0deg);
}
.cd-nav-trigger::before,
.cd-nav-trigger::after {
  /* 2 rounded colored backgrounds for the menu icon */
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  height: 100%;
  width: 100%;
  /* Force Hardware Acceleration in WebKit */
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition-property: -webkit-transform;
  -moz-transition-property: -moz-transform;
  transition-property: transform;
}
.cd-nav-trigger::before {
  background-color: #ffffff;
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
  -webkit-transition-duration: 0.3s;
  -moz-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-delay: 0.4s;
  -moz-transition-delay: 0.4s;
  transition-delay: 0.4s;
}
.cd-nav-trigger::after {
  background-color: #768ede;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
  -webkit-transition-duration: 0s;
  -moz-transition-duration: 0s;
  transition-duration: 0s;
  -webkit-transition-delay: 0s;
  -moz-transition-delay: 0s;
  transition-delay: 0s;
}
.cd-nav-trigger.close-nav::before {
  /* user clicks on the .cd-nav-trigger element - 1st rounded background disappears */
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
}
.cd-nav-trigger.close-nav::after {
  /* user clicks on the .cd-nav-trigger element - 2nd rounded background appears */
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
  -webkit-transition-duration: 0.3s;
  -moz-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-delay: 0.4s;
  -moz-transition-delay: 0.4s;
  transition-delay: 0.4s;
}
.cd-nav-trigger.close-nav .cd-icon {
  /* user clicks on the .cd-nav-trigger element - transform the icon */
  background-color: rgba(255, 255, 255, 0);
}
.cd-nav-trigger.close-nav .cd-icon::before,
.cd-nav-trigger.close-nav .cd-icon::after {
  background-color: white;
}
.cd-nav-trigger.close-nav .cd-icon::before {
  -webkit-transform: translateY(0) rotate(45deg);
  -moz-transform: translateY(0) rotate(45deg);
  -ms-transform: translateY(0) rotate(45deg);
  -o-transform: translateY(0) rotate(45deg);
  transform: translateY(0) rotate(45deg);
}
.cd-nav-trigger.close-nav .cd-icon::after {
  -webkit-transform: translateY(0) rotate(-45deg);
  -moz-transform: translateY(0) rotate(-45deg);
  -ms-transform: translateY(0) rotate(-45deg);
  -o-transform: translateY(0) rotate(-45deg);
  transform: translateY(0) rotate(-45deg);
}

.cd-primary-nav {
  /* by default it's hidden */
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  padding: 80px 5%;
  z-index: 3;
  background-color: #ffffff;
  overflow: auto;
  /* this fixes the buggy scrolling on webkit browsers - mobile devices only - when overflow property is applied */
  -webkit-overflow-scrolling: touch;
  visibility: hidden;
  opacity: 0;
  -webkit-transition: visibility 0s, opacity 0.3s;
  -moz-transition: visibility 0s, opacity 0.3s;
  transition: visibility 0s, opacity 0.3s;
}
.cd-primary-nav li {
  list-style-type: none;
  margin: 1.6em 0;
  text-align: center;
  text-transform: capitalize;
}
.cd-primary-nav a {
  color: #768ede;
  font-size: 20px;
  font-size: 1.25rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-transition: color 0.2s;
  -moz-transition: color 0.2s;
  transition: color 0.2s;
}

.no-touch .cd-primary-nav a:hover {
  color: #ffffff;
}
.cd-primary-nav.fade-in {
  /* navigation visible at the end of the circle animation */
  visibility: visible;
  opacity: 1;
}
@media only screen and (min-width: 768px) {
  .cd-primary-nav li {
    margin: 2em 0;
  }
  .cd-primary-nav a {
    font-size: 28px;
    font-size: 1.75rem;
  }
}
@media only screen and (min-width: 1170px) {
  .cd-primary-nav li {
    margin: 2.6em 0;
  }
  .cd-primary-nav a {
    font-size: 32px;
    font-size: 2rem;
  }
}

.cd-overlay-nav,
.cd-overlay-content {
  /* containers of the 2 main rounded backgrounds - these containers are used to position the rounded bgs behind the menu icon */
  position: fixed;
  top: 18px;
  right: 5%;
  height: 4px;
  width: 4px;
  -webkit-transform: translateX(-20px) translateY(20px);
  -moz-transform: translateX(-20px) translateY(20px);
  -ms-transform: translateX(-20px) translateY(20px);
  -o-transform: translateX(-20px) translateY(20px);
  transform: translateX(-20px) translateY(20px);
}
.cd-overlay-nav span,
.cd-overlay-content span {
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  /* Force Hardware Acceleration in WebKit */
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  will-change: transform;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
}
.cd-overlay-nav.is-hidden,
.cd-overlay-content.is-hidden {
  /* background fades out at the end of the animation */
  opacity: 0;
  visibility: hidden;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  transition: opacity 0.3s 0s, visibility 0s 0.3s;
}

.cd-overlay-nav {
  /* main rounded colored bg 1 */
  z-index: 2;
}
.cd-overlay-nav span {
  background-color: #fff;
}

.cd-overlay-content {
  /* main rounded colored bg 2 */
  z-index: 4;
}
.cd-overlay-content span {
  background-color: #768ede;
}

/* Remove XL screen container (Replaced with lg container) */
@media only screen and (min-width: 1904px) {
  .container {
    max-width: 1185px !important;
  }
}

.home-area {
  width: 100%;
  /* background: url('/img/header-bg.jpg') no-repeat scroll center bottom / cover; */
  padding-top: 150px;
  /* height: 500px; */
  color: #ffffff;
  margin-bottom: 100px;
}

.home-area .mobile-image {
  margin-right: 0;
  margin-left: 0;
  margin-bottom: -90px;
}

.home-area .web-mobile-image {
  margin-right: 0;
  margin-left: 0;
  margin-bottom: -90px;
}

.angle,
.overlay {
  position: relative;
  z-index: 1;
}

.overlay:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* IE6-9 fallback on horizontal gradient */
  z-index: -2;
}

.softShift {
  background: rgb(100, 216, 243, 0.7);
  background: -webkit-linear-gradient(
    45deg,
    rgba(72, 44, 191, 1) 0%,
    rgba(106, 198, 240, 1) 50%
  );
  background: -o-linear-gradient(
    45deg,
    rgba(72, 44, 191, 1) 0%,
    rgba(106, 198, 240, 1) 50%
  );
  background: linear-gradient(
        45deg,
        rgba(39, 86, 216, 0.7),
        rgba(100, 216, 243, 0.6),
        rgba(72, 44, 191, 0.4),
        rgba(202, 106, 240, 0.6),
        rgba(52, 219, 216, 0.7)
      )
      0 0 / 1000% no-repeat,
    url("/img/headerbg/bg0.jpg") 0 0 / cover no-repeat;
  -webkit-animation: gradientAnimation 40s ease infinite;
  animation: gradientAnimation 40s ease infinite;
  opacity: 0.8;
}

@-webkit-keyframes gradientAnimation {
  0% {
    background-position: 0% 30%, 0 0;
  }
  50% {
    background-position: 100% 70%, 0 0;
  }
  100% {
    background-position: 0% 30%, 0 0;
  }
}

@keyframes gradientAnimation {
  0% {
    background-position: 0% 30%, 0 0;
  }
  50% {
    background-position: 100% 70%, 0 0;
  }
  100% {
    background-position: 0% 30%, 0 0;
  }
}

.angle:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  background: rgba(0, 0, 0, 0) -webkit-linear-gradient(
      left bottom,
      #ffffff 48%,
      transparent 52%
    ) repeat scroll 0 0;
  background: rgba(0, 0, 0, 0) -webkit-gradient(
      linear,
      left bottom,
      right top,
      color-stop(48%, #ffffff),
      color-stop(52%, transparent)
    ) repeat scroll 0 0;
  background: rgba(0, 0, 0, 0) -o-linear-gradient(
      left bottom,
      #ffffff 48%,
      transparent 52%
    ) repeat scroll 0 0;
  background: rgba(0, 0, 0, 0)
    linear-gradient(to right top, #ffffff 48%, transparent 52%) repeat scroll 0
    0;
  z-index: -1;
}
.landing-header-text {
    font-size: 3rem !important;
  }

/* Medium Layout: 1280px. */
@media only screen and (min-width: 961px) and (max-width: 1264px) {
  .mainmenu-area ul.nav.navbar-nav li a {
    margin: 0 10px;
  }
  .angle:after {
    height: 60px;
  }
  .landing-header-text {
    font-size: 2.5rem !important;
  }
}

/* Tablet Layout: 768px. */
@media only screen and (min-width: 601px) and (max-width: 960px) {
  .home-area {
    /* padding: 90px 0; */
    padding-bottom: 100px;
    margin-bottom: 0;
  }
  .mobile-image {
    display: none !important;
  }
  .angle:after {
    height: 60px;
  }
}

/* Mobile Layout: 320px. */
@media only screen and (max-width: 600px) {
  .bttn-white {
    padding: 8px 30px;
  }
  .angle:after {
    height: 40px;
  }
  /*-- Home-Area --*/
  .home-area {
    padding-top: 100px;
    padding-bottom: 100px;
    margin-bottom: 0;
  }
  .mobile-image {
    display: none !important;
  }
}

/* Wide Mobile Layout: 480px. */
@media only screen and (min-width: 480px) and (max-width: 767px) {
}

.bttn-white {
  position: relative;
  background: rgb(72, 44, 191);
  background: -webkit-linear-gradient(
    45deg,
    rgba(72, 44, 191, 1) 0%,
    rgba(106, 198, 240, 1) 100%
  );
  background: -o-linear-gradient(
    45deg,
    rgba(72, 44, 191, 1) 0%,
    rgba(106, 198, 240, 1) 100%
  );
  background: linear-gradient(
    45deg,
    rgba(72, 44, 191, 1) 0%,
    rgba(106, 198, 240, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#482cbf', endColorstr='#6ac6f0', GradientType=1);
  overflow: hidden;
  z-index: 1;
  margin-right: 10px;
  border: none;
}

.bttn-white img {
  height: 20px;
  margin-right: 5px;
  margin-top: -5px;
  display: inline-block;
}

.bttn-white:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: -1;
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
  opacity: 1;
}

.bttn-white.active,
.bttn-white:hover {
  color: #ffffff;
}

.bttn-white.active:before,
.bttn-white:hover:before {
  opacity: 0;
}

.bttn-default,
.bttn-white {
  padding: 12px 30px;
  background-color: #ffffff;
  display: inline-block;
  color: #768ede;
  text-transform: uppercase;
  border-radius: 50px;
  letter-spacing: 1.5px;
  font-weight: 400;
  font-size: 14px;
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
  border: none;
  opacity: 0.85;
}

.bttn-default .lnr,
.bttn-white .lnr {
  margin-right: 10px;
}

/* VueTyper Writer */
.vue-typer .custom.char.typed {
  color: #fff;
}
</style>
